import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React, { ReactNode } from "react";
import { Draggable } from "react-beautiful-dnd";
import { AppChartType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IChartDesignerChartPickerItemProps {
    taskChartType: AppChartType;
    index: number;
    title: string;
    icon: ReactNode;
}

const ListItemButtonContent = ({ title, icon }: IChartDesignerChartPickerItemProps) => {
    return (
        <>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{title}</ListItemText>
        </>
    );
};

export const getRenderItem =
  (items: IChartDesignerChartPickerItemProps[]) =>
      // eslint-disable-next-line react/display-name
      (provided, _snapshot, rubric) =>
          (
              <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
              >
                  <ListItemButton
                      sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          transition: "0.001s !important",
                      }}
                  >
                      <ListItemButtonContent {...items[rubric.source.index]} />
                  </ListItemButton>
              </div>
          );

export const ChartDesignerChartPickerItem = (props: IChartDesignerChartPickerItemProps) => {
    const renderItem = getRenderItem([props]);

    return (
        <Box sx={{ height: "42px" }}>
            <ListItemButton
                sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    position: "absolute",
                    width: "100%",
                }}
            >
                <ListItemButtonContent {...props} />
            </ListItemButton>
            <Draggable
                draggableId={props.taskChartType.toString(10)}
                key={props.taskChartType}
                index={props.index}
            >
                {renderItem}
            </Draggable>
        </Box>
    );
};

export const getTaskChartDesignerChartTitle = (taskChartType: AppChartType) => {
    switch (taskChartType) {
    case AppChartType.BarChart:
        return Translations.BarChart;
    case AppChartType.LineChart:
        return Translations.LineChart;
    case AppChartType.PieChart:
        return Translations.PieChart;
    default:
        return "";
    }
};